export default __webpack_public_path__ + "static/media/scrollRight2.5b0f8af3.jpg";